import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { NgStyle } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { IWebConfig } from 'src/app/shared/model/IWebConfig';
import { TranslatePipe } from '@ngx-translate/core';
import { WebConfigService } from '../../services/web-config/web-config.service';
import { ResetPasswordFormStepComponent } from './reset-password-form-step/reset-password-form-step.component';
import { ResetPasswordPinStepComponent } from './reset-password-pin-step/reset-password-pin-step.component';
import { ResetPasswordService } from './reset-password.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  imports: [TranslatePipe, RouterLink, NgStyle, ResetPasswordPinStepComponent, ResetPasswordFormStepComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ResetPasswordComponent implements OnInit {
  private webconfig: IWebConfig = inject(WebConfigService);
  #resetPasswordService = inject(ResetPasswordService);
  #logger = inject(NGXLogger);
  #route = inject(ActivatedRoute);
  #router = inject(Router);

  public logo;
  public logoWhite;
  public portalId: string;
  public loginType: string;

  public loginRoute = 'auth/login';
  public backgroundImage;

  public passwordRequested = signal(false);
  public passwordToken = '';

  public ngOnInit(): void {
    this.logo = this.webconfig.assets.logo;
    this.logoWhite = this.webconfig.assets.logoWhite;
    this.portalId = this.webconfig.portalId;
    this.loginType = this.webconfig.loginType.toLocaleLowerCase();
    this.backgroundImage = this.webconfig.assets.authScreenBackground;
    this.passwordToken = this.#route.snapshot.paramMap.get('token') || '';
    this.#logger.debug(this.passwordToken);
  }

  public async onPasswordSubmit(password: string): Promise<void> {
    const success = await this.#resetPasswordService.resetPassword(this.passwordToken, password, this.loginType);
    if (success) {
      this.passwordRequested.set(true);
      this.#router.navigate([this.loginRoute]);
    }
  }
}
